import React from 'react';
import { useSetActiveEditorCallback, useSetRightSidebarCallback, } from 'js/file_viewer/api/navigation';
import { useFileViewerContext } from 'js/file_viewer/contexts/file_viewer';
import { PDF_EDITOR_PLUGIN_ID, PHOTO_EDITOR_PLUGIN_ID, TRANSCRIPT_BLADE_PLUGIN_ID, VIDEO_EDITOR_PLUGIN_ID, } from 'js/file_viewer/core/data/types';
import { UserActionContext, UserAction } from 'js/file_viewer/core/logging/constants';
import { useCurrentPreviewMetadata } from 'js/file_viewer/core/queries/preview_metadata';
import { PreviewType } from 'js/file_viewer/core/types/preview_type';
export const useMaybeOpenEditorBasedOnUrl = () => {
    const { logUserAction } = useFileViewerContext();
    const previewMetadata = useCurrentPreviewMetadata();
    const previewType = previewMetadata.previewType;
    const setActiveEditorCallback = useSetActiveEditorCallback();
    const activatePDFEditMode = React.useCallback(() => {
        setActiveEditorCallback(PDF_EDITOR_PLUGIN_ID, UserActionContext.PostDownloadEditModal);
        logUserAction(UserAction.EditPdf, UserActionContext.PostDownloadEditModal);
    }, [logUserAction, setActiveEditorCallback]);
    const activateImageEditMode = React.useCallback(() => {
        setActiveEditorCallback(PHOTO_EDITOR_PLUGIN_ID, UserActionContext.PostDownloadEditModal, {
            initialAction: 'adjust',
        });
        logUserAction(UserAction.EditImageAttempt, UserActionContext.PostDownloadEditModal, {
            entryAction: 'adjust',
        });
    }, [logUserAction, setActiveEditorCallback]);
    const activateVideoEditMode = React.useCallback(() => {
        setActiveEditorCallback(VIDEO_EDITOR_PLUGIN_ID, UserActionContext.Initialization, {
            initialEditAction: 'crop',
        });
        logUserAction(UserAction.EditVideoAttempt, UserActionContext.PostDownloadEditModal, {
            entryAction: 'crop',
        });
    }, [logUserAction, setActiveEditorCallback]);
    const activateAudioEditMode = React.useCallback(() => {
        setActiveEditorCallback(VIDEO_EDITOR_PLUGIN_ID, UserActionContext.Initialization, {
            initialEditAction: 'trim',
        });
        logUserAction(UserAction.EditVideoAttempt, UserActionContext.PostDownloadEditModal, {
            entryAction: 'trim',
        });
    }, [logUserAction, setActiveEditorCallback]);
    React.useEffect(() => {
        const onHashChange = () => {
            if (window.location.hash === '#edit') {
                if (previewType === PreviewType.Image) {
                    activateImageEditMode();
                }
                else if (previewType === PreviewType.Video) {
                    activateVideoEditMode();
                }
                else if (previewType === PreviewType.Audio) {
                    activateAudioEditMode();
                }
                else {
                    activatePDFEditMode();
                }
            }
        };
        window.addEventListener('hashchange', onHashChange, false);
        return () => {
            window.removeEventListener('hashchange', onHashChange);
        };
    }, [
        activatePDFEditMode,
        activateImageEditMode,
        activateVideoEditMode,
        previewType,
        activateAudioEditMode,
    ]);
};
export const useMaybeOpenTranscriptSidebarBasedOnUrl = () => {
    const setRightSidebarCallback = useSetRightSidebarCallback(UserActionContext.Initialization);
    React.useEffect(() => {
        const url = new URL(window.location.href);
        if (url.searchParams.get('transcript')) {
            url.searchParams.delete('transcript');
            window.history.replaceState(null, '', url.href);
            setRightSidebarCallback(TRANSCRIPT_BLADE_PLUGIN_ID);
        }
    }, [setRightSidebarCallback]);
};
//# sourceMappingURL=auto_open.preenvesnextjs.map
